<template>
  <div class="tw-flex tw-flex-col tw-h-screen" :class="{ uat }">
    <div class="tw-flex tw-flex-col tw-items-center tw-pb-8">
      <img v-if="logo" :src="logo" @error="displayPlaceholder" class="tw-w-24" />
      <h3 class="tw-pt-3 tw-text-lg tw-font-bold tw-text-center tw-text-white">
        {{ activeEntity }}
      </h3>
      <h4 class="tw-pb-8 tw-text-white tw-uppercase">{{ activeRole }}</h4>
      <button
        id="switchRole"
        @click="() => this.$emit('displayRolesModal', true)"
        @change="checkRefereeAssociation"
        v-if="hasRoles"
        class="tw-h-8 tw-text-sm tw-not-italic tw-font-medium tw-tracking-normal tw-text-center tw-text-white tw-capitalize tw-bg-white tw-rounded tw-leading-11px tw-bg-opacity-20 tw-w-200"
      >
        Switch Role
      </button>
    </div>

    <div class="tw-flex-1 tw-pb-20 tw-overflow-y-scroll">
      <el-menu
        :key="componentKey"
        :collapse="isCollapse"
        :default-active="activeIndex"
        class="el-menu-sidebar"
        :router="true"
        background-color="#0D0D0D"
        text-color="#fff"
        active-text-color="#848484"
      >
        <el-menu-item-group class="scrollable-container">
          <el-menu-item index="/" @click="closeSideBar" class="tw-flex tw-items-center tw-py-4">
            <span
              class="tw-justify-center tw-px-3 tw-text-base tw-not-italic tw-font-bold tw-text-white"
              >Dashboard</span
            >
          </el-menu-item>
          <el-menu-item
            id="teamList"
            class="tw-flex tw-items-center tw-py-4"
            index="/team-lists"
            @click="closeSideBar"
            v-if="
              [roles.teamAdmin, roles.clubAdmin, roles.gamedayAdmin].includes(clearance) &&
              !isRefereeAssociation &&
              !isRefereeClub
            "
          >
            <span
              class="tw-flex tw-items-center tw-text-base tw-not-italic tw-font-normal tw-text-white tw-px-7"
              >Team Lists</span
            >
          </el-menu-item>
          <el-menu-item
            index="/matches"
            class="tw-flex tw-items-center tw-py-4"
            @click="closeSideBar"
            v-if="
              [roles.teamAdmin, roles.clubAdmin, roles.gamedayAdmin].includes(clearance) &&
              !isRefereeAssociation &&
              !isRefereeClub
            "
          >
            <span
              class="tw-flex tw-items-center tw-text-base tw-not-italic tw-font-normal tw-text-white tw-px-7"
              >Matches</span
            >
          </el-menu-item>
          <el-menu-item
            index="/refereeappointments"
            class="tw-flex tw-items-center tw-py-4"
            @click="closeSideBar"
            v-if="
              ([roles.gamedayAdmin].includes(clearance) && isRefereeAssociation) ||
              ([roles.clubAdmin].includes(clearance) && isRefereeClub)
            "
          >
            <span
              class="tw-flex tw-items-center tw-text-base tw-not-italic tw-font-normal tw-text-white tw-px-7"
              >Referee Appointments</span
            >
          </el-menu-item>
          <el-menu-item
            index="/squad-management"
            class="tw-flex tw-items-center tw-py-4"
            v-if="clearance === roles.clubAdmin"
            @click="closeSideBar"
          >
            <span
              class="tw-flex tw-items-center tw-text-base tw-not-italic tw-font-normal tw-text-white tw-px-7"
              >Squads</span
            >
          </el-menu-item>
          <el-menu-item
            index="/my-members"
            class="tw-flex tw-items-center tw-py-4"
            @click="closeSideBar"
            v-if="
              [
                roles.teamAdmin,
                roles.clubAdmin,
                roles.programAdmin,
                roles.clubProgramAdmin,
              ].includes(clearance)
            "
          >
            <span
              class="tw-flex tw-items-center tw-text-base tw-not-italic tw-font-normal tw-text-white tw-px-7"
              >My Members</span
            >
          </el-menu-item>
          <el-menu-item
            index="/training-participants"
            class="tw-flex tw-items-center tw-py-4"
            v-if="
              [
                roles.teamAdmin,
                roles.clubAdmin,
                roles.programAdmin,
                roles.clubProgramAdmin,
              ].includes(clearance)
            "
            @click="closeSideBar"
          >
            <span
              class="tw-flex tw-items-center tw-text-base tw-not-italic tw-font-normal tw-text-white tw-px-7"
              >Training Attendance</span
            >
          </el-menu-item>

          <el-menu-item
            index="/injury-cases"
            class="tw-flex tw-items-center tw-py-4"
            v-if="
              [
                roles.teamAdmin,
                roles.clubAdmin,
                roles.programAdmin,
                roles.gamedayAdmin,
                roles.clubProgramAdmin,
              ].includes(clearance) && this.$store.getters['user/activeRole'].national_id === 32
            "
            @click="closeSideBar"
          >
            <span
              class="tw-flex tw-items-center tw-text-base tw-not-italic tw-font-normal tw-text-white tw-px-7"
              >Injury Cases</span
            >
          </el-menu-item>
          <el-menu-item
            index="/injury-cases-add"
            class="tw-flex tw-items-center tw-py-4"
            v-if="
              [
                roles.teamAdmin,
                roles.clubAdmin,
                roles.programAdmin,
                roles.gamedayAdmin,
                roles.clubProgramAdmin,
              ].includes(clearance) && this.$store.getters['user/activeRole'].national_id === 32
            "
            @click="closeSideBar"
          >
            <span
              class="tw-flex tw-items-center tw-text-base tw-not-italic tw-font-normal tw-text-white tw-px-7"
              >Report Injury</span
            >
          </el-menu-item>
        </el-menu-item-group>
        <br />
        <br /><br /><br />
      </el-menu>
    </div>
    <el-row class="logout-bar">
      <el-button
        class="tw-w-280px sm:tw-w-380px"
        size="small"
        id="logout-button"
        @click="clickLogout"
      >
        {{ myname }} <i class="el-icon-switch-button"></i>
      </el-button>
    </el-row>
  </div>
</template>
<script>
import { orgtree, roles } from "../utils/constants";
import { getS3URL } from "../utils/utilities";

export default {
  name: "SideBar",
  props: {},
  data() {
    return {
      componentKey: 0,
      activeIndex: "/",
      displayUserRoles: false,
      isCollapse: false,
      roles,
      isRefereeAssociation: false,
      isRefereeClub: false,
    };
  },
  mounted() {
    // Set default index while refresh
    const { fullPath } = this.$route;
    const split = fullPath.split("/");
    if (split.length > 1) this.activeIndex = `/${split[1]}`;

    // Check for gameday check if it is referee association/club
    if (this.$store.getters["user/activeRole"].type === roles.gamedayAdmin) {
      this.$http
        .get("/nrl/api/v1/admin/referee/association")
        .then((response) => {
          if (response?.data?.association?.orgtree?.state?.type === "referee") {
            this.isRefereeAssociation = true;
          } else this.isRefereeAssociation = false;
        })
        .catch(() => {
          this.$customError();
        });
    } else if (this.$store.getters["user/activeRole"].type === roles.clubAdmin) {
       this.$http.get("/nrl/api/v1/admin/referee/club").then((response) => {
          if (response?.data?.club?.orgtree?.state?.type === "referee") {
            this.isRefereeClub = true;
          } else this.isRefereeClub = false;
        })
        .catch(() => {
          this.$customError();
        });
    }
  },
  computed: {
    async checkRefereeAssociation() {
      // Check for gameday check if it is referee association
      if (this.$store.getters["user/activeRole"].type === roles.gamedayAdmin) {
        await this.$http
          .get("/nrl/api/v1/admin/referee/association")
          .then((response) => {
            if (response?.data?.association?.orgtree?.state?.type === "referee") {
              this.isRefereeAssociation = true;
            } else this.isRefereeAssociation = false;
          })
          .catch(() => {
            this.$customError();
          });
      } else if (this.$store.getters["user/activeRole"].type === roles.clubAdmin) {
       this.$http.get("/nrl/api/v1/admin/referee/club").then((response) => {
            if (response?.data?.club?.orgtree?.state?.type === "referee") {
              this.isRefereeClub = true;
            } else this.isRefereeClub = false;
          })
          .catch(() => {
            this.$customError();
          });
      }
    },
    uat() {
      return false; // process.env.VUE_APP_ENV === 'test';
    },
    logo() {
      const { entity } = this.$store.getters["user/activeRole"];
      return entity ? getS3URL(entity._id) : false;
    },
    isAuthenticated() {
      return this.$store.getters["user/isAuthenticated"];
    },
    hasRoles() {
      return this.$store.getters["user/roles"] && this.$store.getters["user/roles"].length > 0;
    },
    myname() {
      return this.$store.getters["user/userName"];
    },
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
    activeRole() {
      const roleType = this.$store.getters["user/activeRole"].type;

      return roleType && roleType === 105 && orgtree[roleType]
        ? "Club Program Admin"
        : roleType && roleType !== 99 && orgtree[roleType]
        ? orgtree[roleType].name
        : "Program Admin";
    },
    activeRoleId() {
      return this.$store.getters["user/activeRole"]._id;
    },
    activeEntity() {
      const role = this.$store.getters["user/activeRole"];

      return role.entity ? role.entity.name : "";
    },
  },
  methods: {
    closeSideBar() {
      this.$emit("change-route");
    },
    clickLogout() {
      this.$store.commit("user/logout");
      this.$router.push("/login");
    },
    displayPlaceholder(event) {
      event.target.src = require("../assets/shield_white.svg");
    },
    async chechForRefereeAssociationClub() {
      const roleType = this.$store.getters["user/activeRole"].type
      if (roleType === roles.gamedayAdmin) {
        this.$http
          .get("/nrl/api/v1/admin/referee/association")
          .then((response) => {
            if (response?.data?.club?.orgtree?.state?.type === "referee") {
              this.isRefereeAssociation = true;
            } else this.isRefereeAssociation = false;
          })
          .catch(() => {
            this.$customError();
          });
      } else if (roleType === roles.clubAdmin) {
       this.$http.get("/nrl/api/v1/admin/referee/club").then((response) => {
          if (
            response?.data?.club?.orgtree?.state?.type === "referee"
          ) {
              this.isRefereeClub = true;
            } else this.isRefereeClub = false;
          })
          .catch(() => {
            this.$customError();
          });
      }
    }
  },
  watch: {
    activeRoleId(val) {
      this.activeIndex = "/";
      this.componentKey = val;
    },
    $route(to) {
      this.activeIndex = to.path;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .logout-bar {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;

  #logout-button {
    // width: 70%;
    justify-content: center;
    height: 2.5rem;
    border-radius: 0;
    border: 0 !important;
  }
}
.el-menu {
  border-right: none;
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.el-menu-item {
  height: 32px;
  padding-top: auto;
  padding-bottom: auto;
  i {
    color: #fff;
  }
}

.role-switch-dialog {
  .el-dialog__body {
    padding: 0px 20px 15px 20px;
  }
}

.el-dialog,
.el-dialog__wrapper,
.role-switch-dialog {
  width: 100vw !important;
  height: 100vh !important;
  z-index: 5000 !important;
}

.centered-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.el-button {
  color: #fff !important;
  border: 1px solid #fff !important;
  background: $primary;
}

.el-menu-item {
  &.is-active {
    background-color: #262626 !important;
    color: white !important;

    span {
      font-family: $fontBold !important;
    }
  }
}
</style>
